if (!customElements.get('custom-table-cell')) {
    class CustomTableCell extends HTMLElement {
        constructor() {
            super();
            this.resizeTimeout = null;
        }

        connectedCallback() {
            this.tableContainer = this.querySelector('.custom-table-cell-container');
            this.initTable();
            this.toggleTr();
            this.setupResizeListener();
        }

        initTable() {
            const defaultRow = this.getAttribute('data-default-row');
            if (defaultRow) {
                const table = this.tableContainer.querySelector('table');
                const allRows = table.querySelectorAll('tbody tr');
                const thead = table.querySelector('thead');
                const tbody = table.querySelector('tbody');
                const tbodyTr = tbody.querySelectorAll('tr');
                const tbodyTrCount = tbodyTr.length;
                if (tbodyTrCount > defaultRow) {
                    const button = this.querySelector('.custom-table-cell-expand-button');
                    button.classList.remove('hidden');
                    
                    // 确保 thead 和所有行存在
                    if (thead && allRows.length > 0) {
                        const startIndex = parseInt(defaultRow);
                        const totalHeight = this.calculateVisibleHeight(thead, allRows, startIndex);

                        // 记录折叠时的高度，并设置 table 的最大高度
                        this.tableContainer.setAttribute('data-collapsed-height', totalHeight.toFixed(2));
                        this.tableContainer.style.maxHeight = `${totalHeight.toFixed(2)}px`;
                    }
                }
            }
        }

        calculateVisibleHeight(thead, allRows, startIndex) {
            let totalHeight = thead.offsetHeight;

            // 计算前 defaultRow 行的高度
            for (let i = 0; i < startIndex; i++) {
                totalHeight += allRows[i].offsetHeight;
            }
            return totalHeight;
        }

        toggleTr() {
            const button = this.querySelector('.custom-table-cell-expand-button');
            const defaultRow = this.getAttribute('data-default-row');

            if (button && defaultRow) {
                const table = this.querySelector('table');
                const allRows = table.querySelectorAll('tbody tr');
                const thead = table.querySelector('thead');

                button.addEventListener('click', () => {
                    const collapsedHeight = parseFloat(this.tableContainer.getAttribute('data-collapsed-height'));
                    let totalHeight = thead.offsetHeight;

                    if (this.tableContainer.hasAttribute('open')) {
                        // 折叠状态
                        this.tableContainer.style.maxHeight = `${collapsedHeight}px`;
                        this.toggleText(true);
                        this.tableContainer.removeAttribute('open');
                        button.classList.remove('active');
                    } else {
                        // 展开状态，计算全部行的总高度
                        totalHeight += Array.from(allRows).reduce((sum, row) => sum + row.offsetHeight, 0);
                        this.tableContainer.style.maxHeight = `${totalHeight.toFixed(2)}px`;
                        this.toggleText(false);
                        this.tableContainer.setAttribute('open', '');
                        button.classList.add('active');
                    }
                });
            }
        }

        toggleText(status) {
            const button = this.querySelector('.custom-table-cell-expand-button');
            const text = button.querySelector('span');
            text.textContent = button.getAttribute(status ? 'data-expand' : 'data-contract');
        }

        setupResizeListener() {
            window.addEventListener('resize', this.debounce(() => {
                this.updateMaxHeight();
            }, 500));
        }

        debounce(func, delay) {
            return (...args) => {
                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = setTimeout(() => {
                    func.apply(this, args);
                }, delay);
            };
        }

        updateMaxHeight() {
            const table = this.querySelector('table');
            const allRows = table.querySelectorAll('tbody tr');
            const thead = table.querySelector('thead');
            const defaultRow = this.getAttribute('data-default-row');

            if (thead && allRows.length > 0 && defaultRow) {
                const startIndex = parseInt(defaultRow);
                const totalHeight = this.calculateVisibleHeight(thead, allRows, startIndex);

                if (this.tableContainer.hasAttribute('open')) {
                    // 如果是展开状态，重新设置展开状态下的最大高度
                    const expandedHeight = totalHeight + Array.from(allRows).reduce((sum, row) => sum + row.offsetHeight, 0);
                    this.tableContainer.style.maxHeight = `${expandedHeight.toFixed(2)}px`;

                    // 重新计算并更新 collapsedHeight
                    this.tableContainer.setAttribute('data-collapsed-height', totalHeight.toFixed(2));
                } else {
                    // 如果是折叠状态，更新折叠高度并保存
                    this.tableContainer.setAttribute('data-collapsed-height', totalHeight.toFixed(2));
                    this.tableContainer.style.maxHeight = `${totalHeight.toFixed(2)}px`;
                }
            }
        }
    }

    customElements.define('custom-table-cell', CustomTableCell);
}
